import { ApiError } from './apiFetch';

/**
 * Blocks the whole Word add-in for this team, the same as the upfront Free-plan
 * check — every AI-backed endpoint checks this, so it's never feature-specific.
 */
const ACCOUNT_PLAN_DISABLED_ERROR_TYPES = new Set(['WORD_ADDIN_FREE_PLAN_DISABLED']);

/**
 * Blocks only the one feature that ran out of its metered quota this billing
 * period — other tabs (and other quotas) are unaffected.
 */
const FEATURE_QUOTA_DEPLETED_ERROR_TYPES = new Set([
  'SIGI_CHAT_MESSAGES_QUOTA_DEPLETED',
  'SIGI_GENERATED_CONTRACTS_QUOTA_DEPLETED',
]);

export function isAccountPlanDisabledError(e: unknown): boolean {
  return (
    e instanceof ApiError && !!e.errorType && ACCOUNT_PLAN_DISABLED_ERROR_TYPES.has(e.errorType)
  );
}

export function isFeatureQuotaDepletedError(e: unknown): boolean {
  return (
    e instanceof ApiError && !!e.errorType && FEATURE_QUOTA_DEPLETED_ERROR_TYPES.has(e.errorType)
  );
}
